import BaseballResultsProcessor from "../../entities/BaseballResultsProcessor.js";
import DataSection from "../../enums/DataSection.js";
import ResultDataNew from "../../enums/ResultDataNew.js";
import ScoringType from "../../enums/ScoringType.js";
import Session from "../../enums/Session.js";

const scoringTypePath = ResultDataNew.getDataPath(DataSection.ScoringType.key);

const supportedScoringType = function(session) {
    if (!(session[Session.results.key] instanceof Array)) {
        return false;
    }

    if (session[Session.results.key].length < 1) {
        // we have no proof, it can be false positive here, but we have no choice TBH
        return true;
    }

    const firstResult = session[Session.results.key][0];
    const scoringType = BaseballResultsProcessor.getObjectContent(firstResult, scoringTypePath);
    return (
        // see https://bitbucket.org/flightscope/dto-schema/src/7cc26ca2fbddda72e96c2a756024083ba35837ad/baseball/entity/result-v2.json#lines-93
        // default value may be null for old apps with new scoring (stat grab), which should be treated as "StatGrab"
        scoringType === null
        || typeof(scoringType) === 'undefined'
        || scoringType === ScoringType.extendedTagging.key
        || scoringType === ScoringType.StatGrab.key
    );
};

export default supportedScoringType;